import { render, staticRenderFns } from "./cBox.vue?vue&type=template&id=1a1fd44e&scoped=true&"
import script from "./cBox.vue?vue&type=script&lang=js&"
export * from "./cBox.vue?vue&type=script&lang=js&"
import style0 from "./cBox.vue?vue&type=style&index=0&id=1a1fd44e&scoped=true&lang=scss&"
import style1 from "./cBox.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1fd44e",
  null
  
)

export default component.exports